module.exports = __webpack_public_path__ + "img/Frente-38-00 off.101943de.png";